import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import capaManual from "../../assets/manualCard.png";
import capaManualFornecedores from "../../assets/capa-manual-fornecedores.webp";
import "./_cardManual.scss";

CardManual.propTypes = {
    title: PropTypes.isRequired,
};

CardManual.defaultProps = {
    title: "Manual de preenchimento - 2026",
    src: capaManual,
    hrefCard: "manual-de-preenchimento/Manual do Sistema de Avaliação da Sustentabilidade_PSS_Akatu_Abrafati 2026_PT.pdf",
    hrefCardEn: "manual-de-preenchimento/manual-sistema-avaliacao-english.pdf",
};

function CardManual({ title, src, hrefCard, classBtn, id, hrefCardEn }) {
    const companyRoleId = JSON.parse(localStorage.getItem("@user")).company_data
        ?.company_role?.id;

    if (companyRoleId === 2) {
        hrefCard =
            "manual-de-preenchimento/Fornecedores_Manual do Sistema de Avaliação da Sustentabilidade_PSS_Akatu_Abrafati 2026_PT.pdf";
        hrefCardEn =
            "manual-de-preenchimento/ENG_Fornecedores_Manual do Sistema de Avaliação da Sustentabilidade_PSS_Akatu_Abrafati_2026.pdf";
        if (title?.toLowerCase().includes("manual")) {
            src = capaManualFornecedores;
        }
    }

    return (
        <div className="card-manual">
            <img src={src} alt={`imagem que representa: ${title}`} />
            <h4>{title}</h4>

            {classBtn ? (
                <Link to={`/arquivos/${id}/${title}`}>
                    <button className={classBtn || "btn-manual"}>
                        Acessar arquivos
                    </button>
                </Link>
            ) : (
                <>
                    <a
                        href={hrefCard}
                        download
                        type="application/pdf"
                        className={classBtn || "btn-manual"}
                    >
                        Download - PT
                    </a>

                    <a
                        href={hrefCardEn}
                        download
                        type="application/pdf"
                        className={classBtn || "btn-manual"}
                    >
                        Download - EN
                    </a>
                </>
            )}
        </div>
    );
}

export default CardManual;

